// extracted by mini-css-extract-plugin
export default {"container":"AddElementInfo_container__jCH7C","cost":"AddElementInfo_cost__VZU22","jointInfo":"AddElementInfo_jointInfo__nOhX+","highlighting":"AddElementInfo_highlighting__t5S74"};